export default {
  model (resource) {
    return Object.assign({
      description: null
    }, resource)
  },
  rules () {
    return {
      description: [
        {required: true, message: 'El comentario es requerido'}
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/campaigns/comment.model.js